<div
  class="flex h-full flex-col"
  ptFileUploadDropzone
  (hovered)="onHovered($event)"
  (dropped)="onDropped($event)"
>
  <ng-content />

  @if (isHovering()) {
    <div
      class="border-primary-500 bg-primary-50/10 absolute inset-0 z-[1000] flex items-center justify-center rounded-md border-2 border-dashed"
    ></div>
  }
</div>
